export const getCountriesData = () => {
  return fetch(`/countries-documents.json`).then((response) => {
    const countries = response.json();
    return countries;
  });
};
